import { gql } from 'graphql-request'

export const getUserDashboard = gql`
  query GetUserDashboard{
    getUserDashboard{
        time_credit
        open_holidays
        open_requests
        fixed_weekly_hours
        tracked_weeky_hours
        month_working_days
        month_holidays
        month_sickdays
    }
  }
`

export const getLatestClients = gql`
  query GetLatestClients{
      getLatestClients{
        clients 
    }
  }
`

export const getActiveUsers = gql`
  query allActiveUsers{
    allActiveUsers {
      id
      full_name
    }
  }
`

export const getOvertimeInfo = gql`
  query GetOvertimeInfo(
    $start_date: Date!
    $end_date: Date!
  ){
      getOvertimeInfo(
        start_date: $start_date
        end_date: $end_date
      ) {
        time_credit 
        used_time_credit
      }
    }
`

export const getTracking = gql`
  query GetTrackings(
    $month: Int, 
    $year: Int, 
    $date: Date) {
    getTrackings(
      month: $month, 
      year: $year, 
      date: $date) {
      id
      type
      client
      date
      duration
      comment
      locked
      isEmergency
    }
  }
`

export const getUserRequests = gql`
  query GetUserRequests(
    $status: String
    $approvedPage: Int
    $approvedLimit: Int
    $pendingPage: Int
    $pendingLimit: Int
  ) {
    getUserRequests(
      status: $status
      approvedPage: $approvedPage
      approvedLimit: $approvedLimit
      pendingPage: $pendingPage
      pendingLimit: $pendingLimit
    ) {
      approved {
        data {
          id
          type
          start_date
          end_date
          substitute {
            full_name
            id
          }
          created_at 
          updated_at
        }
        paginatorInfo {
          currentPage
          lastPage
          perPage
          total
        }
      }
      pending {
        data {
          id
          type
          start_date
          end_date
          substitute {
            full_name
            id
          }
          request_type
          edit_payload
          created_at 
          updated_at
        }
        paginatorInfo {
          currentPage
          lastPage
          perPage
          total
        }
      }
    }
  }
`

export const getOfftimeDays = gql`
  query (
    $first: Int!
    $page: Int!
  ){
    getOfftimeDays(
      first: $first
      page: $page
    ){
      data {
        id
        name
        date
        length
        is_holiday
      }
      paginatorInfo {
        currentPage
        lastPage
        total
      }
    }
  }
`

export const getSickTrackings = gql`
  query (
    $first: Int!
    $page: Int!
  ){
    getSickTrackings(
      first: $first
      page: $page
    ){
      data{
        id
        user {
          full_name
        }
        start_date
        end_date
        report_date
      }
      paginatorInfo {
        currentPage
        lastPage
        total
      }
    }
  }
`

export const getUserHasACard = gql`
  query GetUserHasCar{
      me{
        has_car 
    }
  }
`

export const getEvaluationUser = gql`
  query GetEvaluationUser(
    $month: Int!, 
    $year: Int!) {
    getEvaluationUser(
      month: $month, 
      year: $year) {
      month_closed_user
      month_closed_admin
      holiday_overview {
        holiday_used_month
        holiday_total
        holiday_open
        holiday_pending
      }
      time_credit_overview {
        time_credit
        overtime_hours
        overtime_paid
        fixed_time
        overtime_deduction
        remaining_time_credit
        info_time_credit
        info_remaining_time_credit
      }
      weekend_work_overview {
        weekend_emergency_service
        weekend_time_trackings
      }
      separate_payment_overview {
        night_hours
        emergency_service_payment
        expenses_payment
        info_emergency_service_payment
        info_expenses_payment
      }
      hour_overview {
        night_hours
        sunday_hours
        regular_hours
        overtime_hours
        ist_sum_inkl_zuschlag
        month_working_hours
        month_working_days
        tracked_working_days
        sickdays
        weekend_work_days
      }
    }
  }
`

export const getOpenHolidays = gql`
  query GetOpenHolidays($userId: ID) {
    getOpenHolidays(userId: $userId){
      openHoliday, 
      carriedOverHoliday}
  }
`

export const getCheckToken = gql`
  query CheckToken {
    checkToken
  }
`

export const updateTracking = gql`
  mutation UpdateTracking(
    $id: ID!
    $type: TrackingType!
    $start_date: Date!
    $end_date: Date!
    $substitute_id: ID
    $comment: String
    $reason: String
  ) {
    updateTracking(
      id: $id
      type: $type
      start_date: $start_date
      end_date: $end_date
      substitute_id: $substitute_id
      comment: $comment
      reason: $reason
    )
  }
`